import { render } from "./OplAuthorizationFormView.vue?vue&type=template&id=37a68edd&scoped=true"
import script from "./OplAuthorizationFormView.vue?vue&type=script&lang=js"
export * from "./OplAuthorizationFormView.vue?vue&type=script&lang=js"

import "./OplAuthorizationFormView.vue?vue&type=style&index=0&id=37a68edd&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a68edd"]])

export default __exports__